/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CrmAlertComponent } from 'src/app/components/fields';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Report } from 'src/app/model';
import { ReportNote } from 'src/app/model/report.note';
import { ReportNotesProvider } from 'src/app/providers';

@Component({
  selector: 'report-notes-modal',
  templateUrl: './report-notes.modal.html',
  styleUrls: ['./report-notes.modal.scss']
})
export class ReportNotesModal implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;

  subject: Subject<ReportNote>;
  subscription: any;
  report: Report;
  reportNote: ReportNote = new ReportNote();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private noteProvider: ReportNotesProvider,
  ){}

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void{

  }

  onConfirm(): void {
    this.noteProvider.createNote(this.report.ID, this.reportNote)
      .subscribe(data => {
        if(data.success){
          this.bsModalRef.hide();
          this.subject.next(new ReportNote(data.result));
          this.subject.complete();
        }
      });
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }
}
